export default () => ({
  wrapper: {
    margin: 12,
  },
});
